"use strict";
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@material-ui/core");
var react_1 = require("react");
var react_intl_1 = require("react-intl");
var Translation_1 = require("../../../common/components/presentation/Translation/Translation");
var VisaLogo_png_1 = require("../../../common/assets/images/VisaLogo.png");
var MasterCardLogo_1 = require("../../../common/assets/creditCardLogos/MasterCardLogo");
var CreditCardBrands_1 = require("../../../common/enum/CreditCardBrands");
var date_fns_1 = require("date-fns");
var PaymentErrorText = function (_a) {
    var style = _a.style, paymentData = _a.paymentData;
    var _b, _c;
    var intl = react_intl_1.useIntl();
    var paymentInfo = paymentData !== null && ((_b = paymentData) === null || _b === void 0 ? void 0 : _b.transactions.length) ? __spreadArrays((_c = paymentData) === null || _c === void 0 ? void 0 : _c.transactions).pop() : null;
    return (<>
      <core_1.Typography component="h2" variant="h4" data-test="text:paymentError:subTitle" className={style.subTitle}>
        <Translation_1.default id="payment.failed.subtitle"/>
      </core_1.Typography>
      <core_1.Typography component="div" variant="body1" data-test="text:paymentError:description" className={style.paragraph}>
        <Translation_1.default id="payment.failed.description1"/>
      </core_1.Typography>
      {paymentInfo && (<core_1.Box>
          <core_1.Box component="div" className={style.cardContainer}>
            <core_1.Typography component="div" variant="caption" data-test="text:paymentError:cardbrand" className={style.paragraph}>
              <Translation_1.default id="payment.cardDetails.cardBrand"/>
            </core_1.Typography>
            {paymentInfo.brand === CreditCardBrands_1.CreditCardBrands.VISA ? (<img src={VisaLogo_png_1.default} className={style.cardLogo}/>) : (<MasterCardLogo_1.default />)}
          </core_1.Box>
          <core_1.Typography component="div" variant="caption" data-test="text:paymentError:cardNumber" className={style.paragraph}>
            <Translation_1.default id="payment.cardDetails.creditCardMaskInformation"/>
            {paymentInfo.cardNumber}
          </core_1.Typography>
          <core_1.Typography component="div" variant="caption" data-test="text:paymentError:transactionId" className={style.paragraph}>
            <Translation_1.default id="payment.cardDetails.transactionID"/>
            {paymentInfo.externalId}
          </core_1.Typography>
          <core_1.Typography component="div" variant="caption" data-test="text:paymentError:transactionDate" className={style.paragraph}>
            <Translation_1.default id="payment.cardDetails.dateTimeOfPayment"/>
            {date_fns_1.format(date_fns_1.parseISO(paymentInfo.transactionDate), 'dd/MMM/yyyy hh:mm aaa')}
          </core_1.Typography>
          <core_1.Typography component="div" variant="caption" data-test="text:paymentError:actionDescription" className={style.paragraph}>
            <Translation_1.default id="payment.cardDetails.actionDescription"/>
            {paymentInfo.actionDescription}
          </core_1.Typography>
        </core_1.Box>)}
      <core_1.Typography component="div" variant="body1" data-test="text:paymentError:description2" className={style.paragraph}>
        <Translation_1.default id="payment.failed.description2" values={{
        phoneNumber: (<a data-test="text:paymentError:phoneNumber" href={"tel:" + intl.formatMessage({ id: 'label.getInTouch.phoneNumber' })}>
                <Translation_1.default id="label.getInTouch.phoneNumber"/>
              </a>),
    }}/>
      </core_1.Typography>
    </>);
};
exports.default = PaymentErrorText;
